import { TFunction } from 'i18next';
import { CompanyDomain } from 'graphql-common';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';

type ActionsMenuArgs = {
  onVerify: (v?: CompanyDomain) => void;
  onDelete: (v?: CompanyDomain) => void;
  t: TFunction<'translation', undefined>;
};

export default function getTableActionsMenu({
  onVerify,
  onDelete,
  t,
}: ActionsMenuArgs): NavItem<CompanyDomain>[] {
  return [
    {
      id: 'verify-action',
      title: t('verify'),
      onClick: (item?: CompanyDomain) => onVerify(item),
      leftIcon: Icons.verifiedUser,
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: (item?: CompanyDomain) => !item?.verified,
    },
    {
      id: 'delete-action',
      title: t('delete'),
      onClick: (item?: CompanyDomain) => onDelete(item),
      leftIcon: Icons.delete,
      type: NavItemTypeEnum.Secondary,
    },
  ];
}
